import { setActiveSession, useSetUser } from '@zoopla/user';
import { liverampAts } from '../utils/liverampAts';

type User = {
    registrationSources?: (string | null)[] | null;
    userUuid?: string | null;
    brandPrimary?: string | null;
    senderPropertyStatus?: string | null;
    loggedIn?: boolean | null;
    registered?: boolean | null;
    creationDate?: string | null;
    email?: string | null;
};

export const useAuth = () => {
    const setUser = useSetUser();

    const setCurrentSession = (user: User, isNewUser: boolean) => {
        // session cookie
        setActiveSession();

        // set global user data
        // with logged in state
        setUser(user);

        // set liveRamp ads cookie
        liverampAts(user.email || '');

        if (isNewUser) {
            localStorage.setItem('new_register_user', 'true');
        }
    };

    return { setCurrentSession };
};
